import {combineReducers} from 'redux';


import allLoaders from './loaders';
import custom_snackbar from './snackbar';
import login from './pages/user/login';
import verification from './pages/user/verification';
import initialData from './partials/data';
import medicalRecords from './pages/user/medicalRecords';
import visitReq from './pages/user/visitReq';
import main from './pages/main';
import editPersonalInfo from './pages/user/editPersoanlInfo';
import vipServices from './pages/vipServices';
import suggestions from './pages/suggestions';
import surguryConsultation from './pages/surguryConsultation';
import eliteDoctorsMembership from './pages/membershipEliteDoctors';
import visitHistory from './pages/myAdvice/history';
import historyChat from './pages/myAdvice/chat';
import blog from './pages/blog';
import modalRating from './partials/modals/modalRating';

export default combineReducers({
    allLoaders,
    custom_snackbar,
    login,
    verification,
    initialData,
    medicalRecords,
    visitReq,
    main,
    editPersonalInfo,
    vipServices,
    suggestions,
    surguryConsultation,
    eliteDoctorsMembership,
    visitHistory,
    historyChat,
    blog,
    modalRating,
});
